import React from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'
import ProductThumbnail from '../components/Shop/ProductThumbnail'
import { useCart } from '../contexts/CartContext'

const Shop = () => {
  const { t } = useTranslation()
  const { products } = useCart()

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t('SHOP')} description={t('SHOP_DESCRIPTION')} />

      <div className="p-3">
        <p>{t('SHOP_DETAILS')}</p>
        {products.length > 0 && (
          <div className="row g-4">
            {products.map((product) => (
              <div className="col-md-6 col-lg-4 d-flex" key={product.id}>
                <ProductThumbnail product={product} />
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  )
}

export default Shop
